<template>
  <div class="p-inputgroup">
    <span class="p-inputgroup-addon">{{ label }}</span>
    <PrimeCalendar
      v-model="value"
      selectionMode="single"
      dateFormat="yy/mm/dd"
      :showTime="false"
      @date-select="onChange($event)"
      :required="required"
      :disabled="disabled"
    />
  </div>
</template>
 
<script>
export default {
  props: ["modelValue", "label", "required", "disabled"],
  emits: ["update:modelValue", "change"],

  data() {
    return {
      value: null,
    };
  },
  created() {
    this.value = this.modelValue;
  },
  methods: {
    onChange(event) {
      console.log("Calendar onChange");
      console.log(event);
      this.$emit("update:modelValue", this.value);
      this.$emit("change", this.value);
    },
  },
};
</script>
